module.exports = __webpack_public_path__ + "static/media/Check.0d4faacb.svg";